import { Injectable } from '@angular/core';
import { Observable, ReplaySubject, Subscriber, Subscription } from 'rxjs';
import { ApiService } from '../base/api.service';
import { ApiEndpointsService } from '../base/api-endpoints.service';
import { ServerResponse } from '../../interfaces/base/server.response';
import { Tile } from '../../interfaces/routering/tile';

@Injectable()

export class OverviewService {

  public listOfTileIds: number[] = [];
  public listOfTileIdsUpdated: ReplaySubject<boolean> = new ReplaySubject<boolean>(1);

  constructor(private api: ApiService,
              private apiEndpoints: ApiEndpointsService,
  ) {
  }

  tiles(): Observable<any> {
    return new Observable<any>((o: Subscriber<any>) => {
      const subscription: Subscription = this.api.get(this.apiEndpoints.get('overview.tiles'))
        .subscribe((response: ServerResponse|any): void => {
          if (typeof response !== 'undefined') {
            o.next(response);

            this.listOfTileIds = (<any>response).features.map((tile: any): number => tile?.properties?.id);
            this.listOfTileIdsUpdated.next();
          } else {
            o.next(false);
          }
        }, (): void => {
          o.next(false);
        });

      return (): void => {
        subscription.unsubscribe();
      };
    });
  }

  tasks(id: number, formData: any): Observable<Task[] | boolean> {
    return new Observable<Task[] | boolean>((o: Subscriber<Task[] | boolean>) => {
      const subscription: Subscription = this.api.get(this.apiEndpoints.get('overview.tile.tasks', {':tile_id': id}), formData)
        .subscribe((response: ServerResponse): void => {
          if (typeof response.data !== 'undefined') {
            o.next(<Task[]>response.data);
          } else {
            o.next(false);
          }
        }, (): void => {
          o.next(false);
        });

      return (): void => {
        subscription.unsubscribe();
      };
    });
  }

  map(formData: any): Observable<ServerResponse> {
    return this.api.post(this.apiEndpoints.get('overview'), formData);
  }

  getPreviousId(id: number): number | null {
    const index: number = this.listOfTileIds.indexOf(id);
    return index > 0 ? this.listOfTileIds[index - 1] : null;
  }

  getNextId(id: number): number | null {
    const index: number = this.listOfTileIds.indexOf(id);
    return index !== -1 && index < this.listOfTileIds.length - 1 ? this.listOfTileIds[index + 1] : null;
  }
}
